import { render, staticRenderFns } from "./Trash.vue?vue&type=template&id=10f48809&scoped=true&"
import script from "./Trash.vue?vue&type=script&lang=js&"
export * from "./Trash.vue?vue&type=script&lang=js&"
import style0 from "./Trash.vue?vue&type=style&index=0&id=10f48809&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f48809",
  null
  
)

export default component.exports